






































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import PhoneMask from "@/components/ui/PhoneMask.vue";
import FormValidator from "@/mixins/FormValidator";
import {
  Appeal,
  AppealFile,
  EditAppealDto,
  SaveAttachDTO,
} from "../../../../lib/appeal.type";
import { AppealsModule } from "@/store/appeals.module";
import { translate } from "@/utils";
import { FileService } from "@/services/file.service";
import { BaseModule } from "@/store/base.module";
import ConfirmDialog from "@/components/ui/ConfirmDialog.vue";

@Component({ components: { "phone-mask": PhoneMask, ConfirmDialog } })
export default class AppealIn extends Mixins(FormValidator) {
  loading: boolean = false;
  isDragging: boolean = false;
  formRef = "formAppealIn";
  response_text: string = null as any;
  buttonsEnable: boolean = false;

  async saveAppeal() {
    if (!this.validateForm()) {
      return;
    }
    try {
      this.buttonsEnable = false;
      await AppealsModule.sendToRoesAppeal({
        iRequestRid: Number.parseInt(this.$route.params.RequestId),
        nvcResponseDescription: this.response_text,
      });
    } finally {
      this.buttonsEnable = true;
      this.$router.back();
    }
  }

  async onClose() {
    const confrimed = await this.$refs.confirmClose.show();

    if (confrimed) {
      this.$router.back();
    }
  }

  get appealNumber() {
    return this.appealHeader?.request_number;
  }

  get appealHeader(): Appeal | undefined {
    const appeal = AppealsModule.appealInList.find(
      x => x.request_rid.toString() == this.$route.params.RequestId,
    );
    return translate(appeal);
  }

  get canEdit() {
    return this.appealHeader?.request_status_code_name === "state_considering";
  }

  onDragEnter() {
    this.isDragging = true;
  }

  $refs: {
    fileInputRef: any;
    confirmClose: ConfirmDialog;
  };

  onFileChooserClick() {
    this.$refs.fileInputRef.click();
  }

  get fileList() {
    return AppealsModule.fileList;
  }

  get fileListAES() {
    return AppealsModule.fileListAES;
  }

  downloadFile(f: AppealFile) {
    AppealsModule.getFile({
      request_attachment_rid: f.request_attachment_rid,
    }).then(() => {
      const byteOffset = 0;
      const b = new Blob([
        new Uint8Array(
          AppealsModule.fileData.attach_file.data,
          byteOffset,
          length,
        ),
      ]);
      FileService.downloadFile(b, f.attach_file_name);
    });
  }

  deleteFile(request_attachment_rid: number) {
    AppealsModule.deleteFile({
      request_attachment_rid: request_attachment_rid,
    }).then(() => {
      this.reloadFileList();
    });
  }

  async reloadFileList() {
    const rid = this.appealHeader ? this.appealHeader.request_rid : 0;

    await AppealsModule.getFiles({
      iRequestRid: rid,
      data: null as any,
      IsAes: 0,
    });
    await AppealsModule.getFilesAes({
      iRequestRid: rid,
      data: null as any,
      IsAes: 1,
    });
  }

  async fileInputHandler(e: any) {
    const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];

    //проверки
    const ext = file.name
      .substring(file.name.lastIndexOf(".") + 1, file.name.length)
      .toLowerCase();
    const exts = ["png", "jpg", "jpeg", "gif", "pdf"];
    if (exts.indexOf(ext) < 0) {
      return BaseModule.showMessage({
        color: "error",
        message: this.$t("action-send-count.file_ext_error").toString(),
      });
    } else if (file.size > 28 * 1024 * 1024) {
      return BaseModule.showMessage({
        color: "error",
        message: this.$t("action-send-count.file_size_error").toString(),
      });
    }

    const req: SaveAttachDTO = new SaveAttachDTO();
    req.iRequestRid = this.appealHeader ? this.appealHeader?.request_rid : 0;
    const formData = new FormData();
    formData.append("file", file);
    req.data = formData;
    AppealsModule.saveAttach(req).then(() => {
      this.reloadFileList();
    });
  }

  async mounted() {
    if (this.appealHeader) {
      try {
        this.loading = true;
        await AppealsModule.clearFileList();
        await this.reloadFileList();
      } finally {
        this.loading = false;
      }
    } else {
      this.$router.back();
      return;
    }
  }
}
